/* eslint-disable no-undef */
const CONST = require('plugin_frontend_core/constants');

const selectors = {
    popupTitle: '.title a',
    popupStreet: '.street',
    popupZipcode: '.zipcode',
    popupCity: '.city',
    popupPhone: '.telephone',
    popupRoute: '.route a',
    popupStreetview: '.streetview a',
    popupAvailability: '.availability-block',
    popupAvailabilityOpened: '.is-open',
    popupAvailabilityClosed: '.is-closed',
    nearestStores: '.nearest-stores',
    nearestStore: '.nearest-store',
    searchErrorText: '.js-search-error-message',
    storeLocatorMap: '#map',
    storeMap: '#store-map',
    emptyLocatorMapPopup: '.js-content',
    storeLogo: '.store-logo-img',
    searchStoresInput: '.js-search-stores-postal',
    searchStoresButton: '.js-search-stores'
};

const dataNames = {
    newStoresUrl: 'action',
    nearestStoresUrl: 'action-nearest-stores',
    mapLat: 'map-lat',
    mapLong: 'map-long',
    storeLat: 'store-lat',
    storeLong: 'store-long',
    storeZoom: 'zoom',
    markerImg: 'markerimg',
    maxStoreSearchRadius: 'max-radius',
    mapInitialZoom: 'initial-zoom',
    mapSearchZoom: 'search-zoom',
    countryCode: 'country-code',
    errorMsg: 'error-msg'
};

const $locatorMap = $(selectors.storeLocatorMap);
const $storeMap = $(selectors.storeMap);
const $noDataPopup = $(selectors.emptyLocatorMapPopup);
const $storeLogoImg = $(selectors.storeLogo);
const $searchMapInput = $(selectors.searchStoresInput);
const $searchStoresButton = $(selectors.searchStoresButton);
const $searchErrorText = $(selectors.searchErrorText);

let markers = [];
const infowindow = new google.maps.InfoWindow({
    content: ''
});
let actionUrl;
let map;
let maxRadius;
let countryCode;
let nearestStoreUrl;
let searchZoom;
let markerImg;

/**
 * Updates the popup with the new store data of the new clicked marker
 * @param {JQuery} $popup - jquery popup element
 * @param {Object} store - store data from the server
 */
function updatePopupWindow($popup, store) {
    const $title = $popup.find(selectors.popupTitle);
    if ($title.length) {
        $title.text(store.name);
        const oldUrl = $title.attr(CONST.attributes.href);
        const newUrl = `${oldUrl}?storeID=${store.ID}`;
        $title.attr(CONST.attributes.href, newUrl);
    }

    const $street = $popup.find(selectors.popupStreet);
    if ($street.length) {
        $street.text(store.address1);
    }

    const $zipcode = $popup.find(selectors.popupZipcode);
    if ($zipcode.length) {
        $zipcode.text(store.postalCode);
    }

    const $city = $popup.find(selectors.popupCity);
    if ($city.length) {
        $city.text(store.city);
    }

    const $telephone = $popup.find(selectors.popupPhone);
    if ($telephone.length) {
        $telephone.text(store.phone);
    }

    const $route = $popup.find(selectors.popupRoute);
    if ($route.length) {
        const oldUrl = $route.attr(CONST.attributes.href);
        const newUrl = `${oldUrl}&destination=${encodeURIComponent(store.latitude + ',' + store.longitude)}`;
        $route.attr(CONST.attributes.href, newUrl);
    }

    const $streetview = $popup.find(selectors.popupStreetview);
    if ($streetview.length) {
        const oldUrl = $streetview.attr(CONST.attributes.href);
        const newUrl = oldUrl + encodeURIComponent(store.latitude + ',' + store.longitude);
        $streetview.attr(CONST.attributes.href, newUrl);
    }

    const $availabilityBlock = $popup.find(selectors.popupAvailability);
    if ($availabilityBlock.length) {
        if (store.isOpen) {
            $availabilityBlock.find(selectors.popupAvailabilityOpened).addClass(CONST.classes.dInlineBlock);
        } else {
            $availabilityBlock.find(selectors.popupAvailabilityClosed).addClass(CONST.classes.dInlineBlock);
        }
    }
}

/**
 * Used to set/unset a marker on the map (null will unset it)
 * @param {Object} gMap - map
 */
function setMapOnAll(gMap) {
    for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(gMap);
    }
}

/**
 * Replaces the old markers with the new one based on the stores param
 * @param {array} stores - array of stores from the DW
 */
function replaceMarkers(stores) {
    setMapOnAll(null);
    markers = [];

    stores.forEach(store => {
        const marker = new google.maps.Marker({
            position: {
                lat: store.latitude,
                lng: store.longitude
            },
            animation: google.maps.Animation.DROP,
            title: store.name,
            icon: markerImg
        });
        marker.addListener(CONST.events.click, ()=>{
            const $popup = $noDataPopup.clone();
            updatePopupWindow($popup, store);
            infowindow.setContent($popup.prop(CONST.attributes.outerHTML));
            infowindow.open(map, marker);
        });

        markers.push(marker);
    });

    setMapOnAll(map);
}

/**
 * Gets coordinates based on the postal code from google
 * @param {string} postalCode - postal code as a string
 * @return {array} - array containing lat and long
 */
function getLatlongFromPostalCode(postalCode) {
    const geocoder = new google.maps.Geocoder();
    const address = 'postalCode ' + postalCode + ',' + countryCode;

    return new Promise(function (resolve, reject) {
        geocoder.geocode({ address: address }, function (results, status) {
            if (status === 'OK') {
                resolve([results[0].geometry.location.lat(), results[0].geometry.location.lng()]);
            } else {
                reject(new Error('Couldnt\'t find the location ' + address));
            }
        });
    });
}

/**
 * Gets new stores based on the passed params
 * @param {number} lat - latitude
 * @param {number} long - longitude
 * @param {number} radius - radius
 * @param {string} postal - postal code
 */
async function getNewStores(lat, long, radius, postal) {
    $.spinner().start();
    $searchErrorText.text('');
    const data = {};
    if (lat && long) {
        data.lat = lat;
        data.long = long;
    } else if (postal) {
        let coordinates;
        try {
            coordinates = await getLatlongFromPostalCode(postal);
            data.zoom = searchZoom;
            data.lat = coordinates[0];
            data.long = coordinates[1];
        } catch (e) {
            $searchErrorText.text($searchErrorText.data(dataNames.errorMsg));
            return;
        }
    }

    if (radius) {
        data.radius = radius;
    }

    await $.ajax({
        url: actionUrl,
        data: data
    }).done((serverResponse) =>{
        if (!serverResponse.stores) {
            return serverResponse;
        }

        const searchKey = serverResponse.searchKey;
        replaceMarkers(serverResponse.stores);
        map.setCenter(new google.maps.LatLng(searchKey.lat, searchKey.long));
        map.setZoom(parseInt(serverResponse.mapZoom, 10));

        rerenderNearestStores();
        $.spinner().stop();

        return serverResponse;
    })
    .fail((err) => {
        // @TODO - use generic component to display error when ready
        console.error('fn getNewStores', err);
        $.spinner().stop();
    });
}

/**
 * Replaces the nearest store with new stores after the location on the map is changed
 * @return {jqXHR} - ajax response
 */
function rerenderNearestStores() {
    const center = map.getCenter();
    return $.ajax({
        url: nearestStoreUrl,
        data: {
            lat: center.lat(),
            long: center.lng(),
            json: true
        }
    }).done((data) =>{
        if (!data.renderedNearestStores) {
            return data;
        }

        const $newStores = $(data.renderedNearestStores).find(selectors.nearestStore);
        const $oldStores = $(selectors.nearestStores).find(selectors.nearestStore);

        $oldStores.each(function (index, oldStore) {
            const $oldStore = $(oldStore);
            const $newStore = $($newStores.get(index));

            if ($oldStore.attr(CONST.attributes.class) !== $newStore.attr(CONST.attributes.class)) {
                $oldStore.replaceWith($newStore);
            }
        });

        return data;
    })
    .fail((err) => {
        // @TODO - use generic component to display error when ready
        console.log('ERR', err);
    });
}

/**
 * React on store search action from the FE
 */
function storeSearchAction() {
    const postal = $searchMapInput.val();

    if (!postal || postal === '') {
        return;
    }

    getNewStores(null, null, maxRadius, postal);
}


/**
 * Initialize listeners
 */
function initListeners() {
    if (map) {
        $searchMapInput.keyup(function (event) {
            // Number 13 is the "Enter" key on the keyboard
            if (event.keyCode === 13) {
                storeSearchAction();
            }
        });

        $searchStoresButton.click(storeSearchAction);
    }
}

/**
 * Loads the map
 * @param {number} lat latitude
 * @param {number} long longitude
 */
function loadMap(lat, long) {
    const centerLocation = {
        lat: lat,
        lng: long
    };
    const initialZoom = $locatorMap.data(dataNames.mapInitialZoom) ? parseInt($locatorMap.data(dataNames.mapInitialZoom), 10) : 7;

    map = new google.maps.Map(
        $locatorMap.get(0),
        {
            zoom: initialZoom,
            center: centerLocation
        });
    initListeners();
    getNewStores(lat, long, maxRadius);
}

function setMapCenter(lat, long, zoomLevel) {
    if (map) {
        const centerLocation = {
            lat: lat,
            lng: long
        };
        map.setCenter(centerLocation);
        map.setZoom(zoomLevel);
        rerenderNearestStores();
    }
}

/**
 * Initializes the map, and retrieves all the markers from the database
 */
function initMap() {
    if ($locatorMap.length) {
        actionUrl = $locatorMap.data(dataNames.newStoresUrl);
        nearestStoreUrl = $locatorMap.data(dataNames.nearestStoresUrl);
        markerImg = $locatorMap.data(dataNames.markerImg) ? $locatorMap.data(dataNames.markerImg) : null;
        maxRadius = $locatorMap.data(dataNames.maxStoreSearchRadius) ? parseInt($locatorMap.data(dataNames.maxStoreSearchRadius), 10) : 2000;
        searchZoom = $locatorMap.data(dataNames.mapSearchZoom) ? parseInt($locatorMap.data(dataNames.mapSearchZoom), 10) : 10;
        countryCode = $locatorMap.data(dataNames.countryCode) ? $locatorMap.data(dataNames.countryCode) : '';

        // load default map
        const lat = $locatorMap.data(dataNames.mapLat) ? $locatorMap.data(dataNames.mapLat) : 52.1326;
        const long = $locatorMap.data(dataNames.mapLong) ? $locatorMap.data(dataNames.mapLong) : 5.2913;
        loadMap(lat, long);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setMapCenter(position.coords.latitude, position.coords.longitude, searchZoom);
            });
        }
    }
}



/**
 * Initializes the store map on the store page and shows the company logo where the store is
 */
function initStoreIndividualMap() {
    if ($storeMap.length) {
        const lat = $storeMap.data(dataNames.storeLat);
        const long = $storeMap.data(dataNames.storeLong);
        const storeMapZoom = $storeMap.data(dataNames.storeZoom) ? parseInt($storeMap.data(dataNames.storeZoom), 10) : 12;

        const centerLocation = {
            lat: lat,
            lng: long
        };

        const storeMap = new google.maps.Map(
            $storeMap.get(0),
            {
                zoom: storeMapZoom,
                center: centerLocation
            });

        const storeLogo = $storeLogoImg.clone();
        storeLogo.removeClass(CONST.classes.dNone);

        const storeMarker = new google.maps.Marker({
            position: centerLocation
        });

        storeMarker.setMap(storeMap);
    }
}

initMap();
initStoreIndividualMap();
